import { ComponentProps } from "react";
import { Link } from "react-router-dom";

export const StyledLink = ({
  children,
  ...props
}: ComponentProps<typeof Link>) => (
  <Link
    className="text-dm-brand-blue-600 underline-offset-4 hover:text-dm-brand-blue-800 hover:underline"
    {...props}
  >
    {children}
  </Link>
);

export const EmailLink = ({ subject }: { subject?: string }) => {
  const url = new URL("mailto:home@deltamath.com");
  if (subject) {
    url.searchParams.append("subject", subject);
  }
  return <StyledLink to={url.href}>home@deltamath.com</StyledLink>;
};
